import { gql } from '@apollo/client';
import { useQuery } from './apollo';

export const APPLICATION_FEATURE_FLAG_QUERY = gql`
  query applicationFeatureFlag($code: String!) {
    applicationFeatureFlag(code: $code)
  }
`;

export function useApplicationFeature(code) {
  const { data, loading: applicationFeatureLoading } = useQuery(APPLICATION_FEATURE_FLAG_QUERY, {
    variables: { code },
    skip: !code
  });

  return { applicationFeatureFlag: data?.applicationFeatureFlag, loading: applicationFeatureLoading };
}
